// Instrument lists
export const INSTRUMENTS_QPCR = [
  'LightCycler 480II',
  'LightCycler96',
  'LightCycler Pro',
  'Biorad CFX96',
  'Biorad CFX Connect',
  'Biorad CFX Opus 96',
  'CFX Opus 384',
  'QIAquant 96 5plex',
  'QIAquant 96 2plex',
  'QIAquant 384 5plex',
  'Rotor-Gene Q 2plex HRM',
  'Rotor-Gene Q 5plex',
  'Rotor-Gene Q 6plex',
  'Rotor-Gene Q 5plex HRM',
  'QuantStudio 1',
  'QuantStudio 3',
  'QuantStudio 5',
  'QuantStudio 6 Pro',
  'QuantStudio 7 Pro',
  'StepOne',
  'StepOne Plus',
  'AriaMx',
  'AriaDx',
  'Other Instruments'
];

export const INSTRUMENTS_DPCR = [
  'Roche Digital LightCycler',
  'Biorad QX200',
  'Biorad QX600',
  'Biorad QX700',
  'QIAcuity 2plex',
  'QIAcuity 5plex',
  'Thermo QuantStudio Absolute Q',
  'Stilla Naica System',
  'DQ24'
];

export const MIRNA_CONTROLS = [
  'SNORD68(mmu)',
  'SNORD110(mmu)',
  'SNORD65(mmu)',
  'U6 snRNA',
  'SNORD49A (hsa)',
  'RNU1A1',
  'SNORD48 (hsa)',
  'SNORA66 (hsa)',
  'SNORD38B (hsa)',
  'SNORD44 (hsa)'
];

export const REFERENCE_GENES = [
  'GAPDH',
  'ACTB (β-actin)',
  '18S rRNA',
  'HPRT1',
  'TBP',
  'RPLP0',
  'RPLP1',
  'ABL1',
  'RPL13A',
  'GNB2L1',
  'YWHAZ',
  'TUBB',
  'SDHA',
  'B2M'
];

export const SPECIES = [
  'Human',
  'Mouse',
  'Rat',
  'Dog',
  'Cat',
  'Other'
];

// Pricing calculations
export const calculatePrice = (technology, application, config) => {
  const numItems = config.items?.length || 1;

  // Handle genotyping with sub-types
  if (application === 'genotyping') {
    const genotypeType = config.genotype_type;
    
    if (genotypeType === 'taqman') {
      return numItems * 450;
    } else if (genotypeType === 'fret' || genotypeType === 'simplemt') {
      let price = numItems * 500;
      if (config.synthetic_control) {
        price += numItems * 100;
      }
      return price;
    } else if (genotypeType === 'gace') {
      let price = numItems * 200;
      if (config.synthetic_control) {
        price += numItems * 100;
      }
      return price;
    }
    return 0;
  }

  switch (application) {
    case 'gene_expression':
      let genePrice = 0;
      if (technology === 'realtime_pcr') {
        if (config.assay_type === 'sybr_green') {
          genePrice = numItems * 25;
        } else if (config.assay_type === 'hydrolysis_probe') {
          genePrice = (2 * numItems * 10) + (numItems * 200);
        }
      } else if (technology === 'digital_pcr') {
        // dPCR always uses hydrolysis probes
        genePrice = (2 * numItems * 10) + (numItems * 200);
      }
      // Add reference genes cost (€250 each)
      if (config.reference_genes && config.reference_genes.length > 0) {
        genePrice += config.reference_genes.length * 250;
      }
      return genePrice;

    case 'pathogen_detection':
      let price = numItems * 300;
      if (config.positive_control) {
        price += numItems * 100;
      }
      if (config.quantification_control && technology === 'realtime_pcr') {
        price += numItems * 100;
      }
      return price;

    case 'gace_mas':
      let gacePrice = numItems * 200;
      if (config.synthetic_control) {
        gacePrice += numItems * 100;
      }
      return gacePrice;

    case 'mirna':
      if (technology === 'realtime_pcr') {
        if (config.assay_type === 'sybr_green') {
          return numItems * 130;
        } else if (config.assay_type === 'hydrolysis_probe') {
          return (3 * numItems * 15) + (numItems * 200);
        }
      } else if (technology === 'digital_pcr') {
        // dPCR miRNA with reference gene
        let mirnaPrice = (3 * numItems * 15) + (numItems * 200);
        if (config.reference_gene) {
          mirnaPrice += 245;
        }
        return mirnaPrice;
      }
      break;

    default:
      return 0;
  }

  return 0;
};
